import toast from 'react-hot-toast';

const MealDelete = async (id, handleRefreshTrigger, type, userid, apiGlobal) => {
    try {
        // const deletemealUrl = 
        // `https://navrang.mvd-tech.io/API/meal_delete.php?id=${id}&type=${type}&user_id=${userid}`;
        const deletemealUrl = `${apiGlobal}meal_delete.php?id=${id}&type=
        ${type}&user_id=${userid}`;
        // console.log(`Fetching URL: ${deletemealUrl}`);
        
        const deletemealUrlResponse = await fetch(deletemealUrl);

        if (!deletemealUrlResponse.ok) {
            throw new Error(`HTTP error! Status: ${deletemealUrlResponse.status}`);
        }

        const deletemealResponse = await deletemealUrlResponse.json();
        // console.log(deletemealResponse); 

        if (deletemealResponse.status && deletemealResponse.message === 'Meal record deleted successfully') {
            toast.success('Meal deleted successfully');
            // setRefresh(prev => !prev);
            handleRefreshTrigger();
        } else {
            toast.error(deletemealResponse.message);
        }
    } catch (error) {
        console.error('Error occurred during meal deletion:', error);
        toast.error(`Failed to delete: ${error.message}`);
    }
};

export default MealDelete;

